"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getReplyEmailAddress = exports.generateTemplateHeaderAndFooter = void 0;
var _stringUtils = require("./stringUtils");
// OLD CODE *********************
// const generateHeader = (color, logo) => {
//   return `
//         <div style="background: linear-gradient(145deg, #${
//           color ? color : 'e6616a'
//         } 79%, rgba(37,37,37,1) 80%); width: 100%; padding: 1vh; padding-left: 0; padding-right: 0">
//         <div style="background-image: url('${
//           logo ? logo : 'https://gy-prod-public-media.s3-eu-west-1.amazonaws.com/logo.png'
//         }'); background-size:contain; background-position: center center; background-repeat: no-repeat; width: 350px; height: 90px; margin: 0 auto;">
//         </div>
//         </div>
//       `;
// };

// const generateGoodByeMessage = (lang, providerName, logo) =>
//   lang === 'it' ? `Grazie, ${logo ? providerName : 'GURYOU Business Team.'}` : `Thank you, ${logo ? providerName : 'GURYOU Business Team.'}`;

// const generateFooter = color => {
//   return `
//   <div style="background: linear-gradient(145deg,rgba(37,37,37,1) 19%, #${color ? color : 'e6616a'} 20%); width: 100%;">
//   <div style="display:flex; width:75%; margin-left: auto; ${color ? 'height: 18.3vh' : ''}">
//   ${
//     color
//       ? ``
//       : ` <a target="_blank" style="color:white; font-size: 1.9rem; margin: 0rem 3rem; margin-top: 0.3rem;"
//                 href="https://www.facebook.com/guryou/"><img
//                     src=https://gy-prod-public-media.s3-eu-west-1.amazonaws.com/facebook.png /></a>
//             <a target="_blank" style="color:white; font-size: 1.9rem; margin: 0rem 3rem; margin-top: 0.3rem;"
//                 href="https://www.youtube.com/channel/UCW_LkvMb7dGWJrLdflZoAxA"><img
//                     src=https://gy-prod-public-media.s3-eu-west-1.amazonaws.com/youtube.png /></a>
//             <a target="_blank" style="color:white; font-size: 1.9rem; margin: 0rem 3rem; margin-top: 0.3rem;"
//                 href="https://www.linkedin.com/company/gy"><img
//                     src=https://gy-prod-public-media.s3-eu-west-1.amazonaws.com/linkedin.png /></a>
//             <a target="_blank" style="color:white; font-size: 1.9rem; margin: 0rem 3rem; margin-top: 0.3rem;"
//                 href="https://www.instagram.com/guryou_official/"><img
//                     src=https://gy-prod-public-media.s3-eu-west-1.amazonaws.com/instagram.png /></a>`
//   }
//   </div>
//   </div>`;
// };

var getReplyEmailAddress = exports.getReplyEmailAddress = function getReplyEmailAddress(email, notificationEmail) {
  var trimmedEmail = email && email.trim();
  var trimmedNotificationEmail = notificationEmail && notificationEmail.trim();
  if (trimmedNotificationEmail && trimmedNotificationEmail !== process.env.EMAIL_SENDER) {
    return trimmedNotificationEmail;
  }
  return trimmedEmail;
};

// export const generateTemplateHeaderAndFooter = provider => {
//   const { emailTemplate, providerLanguage, name } = provider;
//   return {
//     headerDiv: generateHeader(emailTemplate?.color, emailTemplate?.logo),
//     footerDiv: generateFooter(emailTemplate?.color),
//     goodbyeMessage: generateGoodByeMessage(providerLanguage, name, emailTemplate?.logo),
//   };
// };

// OLD CODE END *********************

var DEFAULT_LOGO = 'https://gy-prod-public-media.s3-eu-west-1.amazonaws.com/logo.png';
var DEFAULT_COLOR = 'e6616a';
var generateGoodByeMessage = function generateGoodByeMessage(lang, providerName, hasCustomLogo) {
  var goodbyeMessage = (0, _stringUtils.getLocalizedString)(lang, {
    en: "Thank you, ".concat(hasCustomLogo ? providerName : 'GURYOU Business Team.'),
    it: "Grazie, ".concat(hasCustomLogo ? providerName : 'GURYOU Business Team.'),
    de: "Danke, ".concat(hasCustomLogo ? providerName : 'GURYOU Business Team.')
  });
  return goodbyeMessage;
};
var generateTemplateHeaderAndFooter = exports.generateTemplateHeaderAndFooter = function generateTemplateHeaderAndFooter(provider) {
  var emailTemplate = provider.emailTemplate,
    language = provider.language,
    name = provider.name;
  var hasCustomLogo = Boolean(emailTemplate === null || emailTemplate === void 0 ? void 0 : emailTemplate.logo);
  return {
    brandColor: (emailTemplate === null || emailTemplate === void 0 ? void 0 : emailTemplate.color) || DEFAULT_COLOR,
    logoUrl: (emailTemplate === null || emailTemplate === void 0 ? void 0 : emailTemplate.logo) || DEFAULT_LOGO,
    goodbyeMessage: generateGoodByeMessage(language, name, hasCustomLogo)
  };
};
